class ClinicalData {
  image = undefined;
  bodyLocation = [];
  patient = undefined;
  qa = {
    nextQuestions: [],
    questions: [],
    answers: []
  }
  inferenceType = undefined;
  inference = {};
  firstGateResult = undefined;

  constructor(parent) {
    this.parent = parent;
    this.clearAllData();
  }

  setImage(image) {
    this.image = image;
    this.clearFirstGateResult();
    this.clearBodyLocation();
    this.clearQaData();
  }

  setImageCrop(crop) {
    this.image = { ...this.image, crop };
  }

  clearImage() {
    this.image = undefined;
  }

  setPatientData(data) {
    this.patient = data;
    this.parent.onPatientDataSet();
  }

  clearPatientData() {
    this.patient = undefined;
  }

  setBodyLocation(data) {
    this.bodyLocation = data;
    this.parent.onBodyLocationSet();
  }

  clearBodyLocation() {
    this.bodyLocation = [];
  }

  setQaAnswers(data) {
    this.qa.answers = data;
    this.parent.onQaAnswersSet();
  }

  clearQaAnswersForQuestions(questions) {
    const questionsIds = questions.map(q => q.id);
    this.qa.answers = this.qa.answers.filter(a => !questionsIds.includes(a.id));
  }

  clearQaAnswers() {
    this.qa.answers = [];
  }

  addQaQuestion(questionString) {
    const questionIndex = this.qa.questions.length;

    const question = {
      id: `qa-question-${questionIndex}`,
      name: questionString,
      choices: [
        { id: 'yes', label: 'Yes'},
        { id: 'no', label: 'No' }
      ]
    };

    this.qa.nextQuestions = [question];
    this.qa.questions = [...this.qa.questions, question];
  }

  popQaQuestion() {
    const poppedQuestion = this.qa.questions.splice(-1);

    this.qa.nextQuestions = this.qa.questions.length > 0 ? [this.qa.questions[this.qa.questions.length - 1]] : [];
    this.qa.answers = this.qa.answers.filter(a => a.id !== poppedQuestion.id);

    if (this.qa.nextQuestions.length == 0) {
      this.parent.history.goBack();
    }
  }

  clearQaQuestions() {
    this.qa.nextQuestions = [];
    this.qa.questions = [];
  }

  clearQaData() {
    this.clearQaQuestions();
    this.clearQaAnswers();
  }

  setInference(data) {
    this.inference = data;
  }

  setFirstGateResult(result) {
    this.firstGateResult = result;

    this.update();
  }

  resolveInferenceType(isClinician) {
    if (!isClinician) {
      this.inferenceType = 'macroscopic';
    } else {
      this.inferenceType = this.firstGateResult.type === 'dermoscopic' ? 'dermoscopic' : 'macroscopic';
    }
  }

  clearFirstGateResult() {
    this.firstGateResult = undefined;
  }

  clearInference() {
    this.inference = {};
  }

  classifyImage() {
    this.parent.classifyImage();
  }

  allPatientData() {
    let patientData = {
      bodyLocation: [],
      questions: []
    };

    this.patient.forEach((entry) => patientData[entry.id] = entry.choice_id );
    this.bodyLocation.forEach((entry) => patientData.bodyLocation.push(entry.id));

    this.qa.questions.forEach((question) => {
      const answer = this.qa.answers.find(answer => answer.id === question.id);

      if (!answer) { return; }

      patientData.questions.push({
        question: question.name,
        answer: answer.choice_id === 'yes' ? true : false
      });
    });

    return patientData;
  }

  allPredictions() {
    if (!this.inference) { return []; }

    return this.inference.predictions.map(prediction => {
      return {
        condition: {
          id: prediction.condition.id,
          name: prediction.condition.name
        },
        probability: prediction.probability
      };
    });
  }

  clearAllData(deletePatientData = false) {
    this.clearImage();
    this.clearFirstGateResult();
    this.clearBodyLocation();
    this.clearQaData();
    this.clearInference();

    if (deletePatientData) {
      this.clearPatientData();
    }
  }

  update() {
    this.parent.setState({ clinicalData: this });
  }
}

export default ClinicalData;
